var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "91px",
    viewBox: "0 0 99 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A43B6A2-5F9E-4E0E-8249-BADDD1C9C6FA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-5",
    transform: "translate(-137.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blocked-members-empty-icon",
    transform: "translate(28.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#CCCCCC",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7178538,0 C52.2870055,0 63.2869764,11.0199459 63.2869764,24.613738 C63.2869764,33.1479554 58.9514915,40.6677271 52.366633,45.0831537 C66.0987038,50.5464765 75.9251698,63.7437205 76.4907488,79.3082431 L-7.51425341e-06,79.3082431 C0.573802711,63.5172009 10.6800196,50.1628435 24.7255798,44.8483905 C18.33411,40.4047697 14.1487311,32.9989152 14.1487311,24.613738 C14.1487311,11.0199459 25.148702,0 38.7178538,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.2679654,87.3781926 C82.8328014,79.1350906 88.3407464,73.4786974 90.7918003,70.4090127 C94.4683813,65.8044858 95.5243485,61.310653 93.1822052,57.4108913 C90.8400618,53.5111296 87.7814413,52.4108913 82.573831,52.4108913 C79.1020908,52.4108913 76.333469,54.077558 74.2679654,57.4108913 C70.5134224,52.8095841 66.4086517,51.1429174 61.9536534,52.4108913 C57.4986551,53.6788652 54.8770329,56.3455318 54.0887866,60.4108913 C53.6053208,63.6518383 55.0963017,67.2954084 58.5617292,71.3416016 C62.0271568,75.3877947 67.2625689,80.7333251 74.2679654,87.3781926 Z",
    id: "heart",
    fill: "#710D0D",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.a67bc9e5fcd4a9e7600063b6540e47fd.svg";
export { ForwardRef as ReactComponent };